import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=0c43abb1&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=0c43abb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43abb1",
  null
  
)

export default component.exports